import $ from 'jquery'

/**
 * Handles checkbox interactions for product comparison
 */
export class CheckboxHandler {
  constructor(state, uiManager, maxCount) {
    this.state = state
    this.uiManager = uiManager
    this.maxCount = maxCount
  }

  attach() {
    const self = this
    
    $('input[name="compare[]"]').off('click').on('click', function() {
      const count = self.uiManager.getProductCount()
      
      if (count >= self.maxCount && this.checked) {
        $(this).prop('checked', '')
        return
      }

      if (this.checked && count < self.maxCount) {
        self.handleCheck($(this))
      } else if (!this.checked) {
        self.handleUncheck($(this))
      }
    })
  }

  handleCheck($checkbox) {
    const id = $checkbox.val()
    const image = $checkbox.data('image')
    const description = $checkbox.data('description')
    
    this.state.add(id, image, description)
    
    const $element = this.uiManager.createCompareElement(id, image, description)
    this.uiManager.addCompareElement($element, this.getCompareContainer())
    
    this.uiManager.updateButtonStates(this.uiManager.getProductCount())
    this.uiManager.updateCounter(this.uiManager.getProductCount())
    this.updateHiddenFieldFromState()
    
    if (!this.isWidgetOpen()) {
      this.uiManager.toggleWidget()
      setTimeout(() => this.uiManager.toggleWidget(), 750)
    }
  }

  handleUncheck($checkbox) {
    const id = $checkbox.val()
    const image = $checkbox.data('image')
    const description = $checkbox.data('description')
    
    $(`.compare-product.${id}`).remove()
    this.state.remove(id, image, description)
    
    this.uiManager.updateButtonStates(this.uiManager.getProductCount())
    this.uiManager.updateCounter(this.uiManager.getProductCount())
    this.updateHiddenFieldFromState()
  }

  getCompareContainer() {
    return this.uiManager.targets.compareContainerTarget
  }

  isWidgetOpen() {
    return this.uiManager.targets.hasWidgetTarget && 
           $(this.uiManager.targets.widgetTarget).hasClass('slide-up-compare')
  }

  updateHiddenFieldFromState() {
    const allIDs = this.state.persist()
    this.uiManager.updateHiddenField(allIDs)
  }
}
